var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tg4-loader",class:{ compact: _vm.compact, small: _vm.small },attrs:{"role":"status"}},[_c('div',{staticClass:"tg4-loader-spinner"}),(!_vm.hideLabel)?_c('p',{staticClass:"tg4-loader-label"},[_vm._v(_vm._s(_setup.props.label ?? _vm.$t('general.loading')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }